import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=5e068cc1"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=5e068cc1&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e068cc1')) {
      api.createRecord('5e068cc1', component.options)
    } else {
      api.reload('5e068cc1', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=5e068cc1", function () {
      api.rerender('5e068cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/preSubject/Slider.vue"
export default component.exports